<div class="col-md-12 mb-2">
  <div class="row">
    <div class="d-flex w-100 banner-form">
      <div class="flex-fill banner-form-fields">
        <label>{{ 'Payer' | translate | async}}</label>
        <div class="d-flex">

          <select class="form-control" [(ngModel)]="billingModel.payerId" (change)="changePayer($event);"
            [disabled]="checkUHID()">
            <option value="" [disabled]="true">{{ 'Select Payer Name' | translate | async}}</option>
            @for (payer of billingModel.getPayerData; track payer) {
              <option [value]="payer.id">{{payer.payer_name}}
              </option>
            }
          </select>
          @if (billingModel.payment_typeId != 'cash') {
            <div class="pl-1">
              <button type="button" class="primary-btn" (click)="openPayerInput($event)"><i
              class="fa fa-plus-circle fa-1x pointer" aria-hidden="true"></i></button>
            </div>
          }
        </div>
      </div>


    </div>
  </div>
</div>